"use client";

import ERPHeroSection from "../ERP/ERPHeroSection/ERPHeroSection";
import ERPImpactSection from "../ERP/ERPImpactSection/ERPImpactSection";
import BusinessModuleSection from "../ERP/BusinessModuleSection/BusinessModuleSection";
import ERPExpertiseSection from "../ERP/ERPExpertiseSection/ERPExpertiseSection";
import ERPCtaSection from "../ERP/ERPCtaSection/ERPCtaSection";
import OperationSection from "../ERP/OperationSection/OperationSection";
import MeasurableSection from "../ERP/MeasurableSection/MeasurableSection";
import PricingTimelineSection from "../ERP/PricingTimelineSection/PricingTimelineSection";
import ImplementationSection from "../ERP/ImplementationSection/ImplementationSection";
import BeforeYouCommitSection from "../ERP/BeforeYouCommitSection/BeforeYouCommitSection";
import WhyBusinessesChooseSection from "../ERP/WhyBusinessesChooseSection/WhyBusinessesChooseSection";
import ERPProcessSection from "../ERP/ERPProcessSection/ERPProcessSection";
import FAQSection from "@/components/FAQSection/FAQSection";
import { odooerpFAQ } from "@/components/FAQSection/faqData";

const ERPServiceLayout = ({ data }) => {
  return (
    <>
      <ERPHeroSection hero={data.hero} />
      <ERPImpactSection impact={data.impact} />
      <ImplementationSection implementation={data.implementation} />
      <BusinessModuleSection module={data.businessModule} />
      <BeforeYouCommitSection BeforeYouCommit={data.BeforeYouCommit} />
      {/* <ERPExpertiseSection expertise={data.expertise} /> */}
      
      <WhyBusinessesChooseSection
        whyBusinessesChoose={data.whyBusinessesChoose}
      />
      
      <ERPProcessSection process={data.process} />
       <MeasurableSection measurable={data.measurable} />
      <OperationSection operation={data.operation} />
     
      <PricingTimelineSection pricingTimeline={data.pricingTimeline} />
      <FAQSection faqData={odooerpFAQ} />
      <ERPCtaSection />
    </>
  );
};

export default ERPServiceLayout;
